import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { MenuItem } from '../../types';
import { MENU_ITEMS } from '../../types/menuItems';

interface SidebarProps {
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onClose }) => {
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = MENU_ITEMS as readonly MenuItem[];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="sidebar w-64 min-h-screen p-6 flex flex-col bg-white shadow-lg lg:shadow-none fixed top-0 left-0 z-50 lg:relative lg:sticky lg:top-0 lg:col-span-1">
      <div className="mb-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="/bsk-icon-v2.png" 
              alt="BSK Icon" 
              className="h-12 w-12"
            />
            <h1 className="text-xl font-bold text-gray-900">BASILISK</h1>
          </div>
          {/* Close button for mobile */}
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition-colors"
            aria-label="Close menu"
          >
            <svg className="h-6 w-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      
      <nav className="flex-1 space-y-1">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={onClose}
            className={`sidebar-item ${
              isActive(item.path) ? 'active' : 'text-gray-600'
            }`}
          >
            <span className="mr-3">{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="pt-6 border-t border-gray-200">
        <button
          onClick={() => {
            logout();
            onClose?.();
          }}
          className="sidebar-item w-full text-gray-600 hover:text-red-600"
        >
          <svg className="h-5 w-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
